import { render, staticRenderFns } from "./MessageSendWithAttachmentView.vue?vue&type=template&id=c0951d5a&scoped=true&"
import script from "./MessageSendWithAttachmentView.vue?vue&type=script&lang=ts&"
export * from "./MessageSendWithAttachmentView.vue?vue&type=script&lang=ts&"
import style0 from "./MessageSendWithAttachmentView.vue?vue&type=style&index=0&id=c0951d5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0951d5a",
  null
  
)

export default component.exports